import PageHeader from "@/components/PageHeader";
import QuoteEstimatorForm from "@/components/QuoteEstimatorForm";

export default function DevisPage() {
  return (
    <>
      <PageHeader
        eyebrow="Demande de devis"
        title="Décrivez votre projet en 2 minutes."
        sub="Décrivez votre objet, joignez des photos ou un croquis (image ou PDF), indiquez vos cotes si vous les connaissez — réponse sous 48 h ouvrées avec un chiffrage détaillé."
        pageTitle="Demander un devis — Impression & modélisation 3D | TroiDéo"
      />
      <QuoteEstimatorForm />
    </>
  );
}
